import { shallowEqual } from 'react-redux'

import { FiltersProps } from './types'

export function propsAreEqual(prevProps: FiltersProps, nextProps: FiltersProps) {
  const configsAreEqual = shallowEqual(prevProps.config, nextProps.config)
  const themesAreEqual = shallowEqual(prevProps.theme, nextProps.theme)
  const otherPropsAreEqual = shallowEqual(
    { ...prevProps, config: null, theme: null },
    { ...nextProps, config: null, theme: null },
  )

  return configsAreEqual && themesAreEqual && otherPropsAreEqual
}
